<!-- @format -->

<info-basic-information-tag>

    <div class="container_contents">

        <div class="container_breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item"><a href="/info" class="information">会員情報</a></li>
                <li class="breadcrumb-item"><h1>登録基本情報</h1></li>
            </ul>
        </div>

        <div class="contents">
            <section class="contents_area">
                <div class="contents_block">
                    <h2 style="font-size: 2.5rem;text-align: center;margin-bottom:1rem">
                        現在の登録基本情報
                    </h2>

                    <h2 class="heading-03 margin-spacing-4_top margin-spacing-2_bottom">登録基本情報</h2>

                    <table class="detail_table">
                        <tr class="detail_table-row">
                            <th class="information_table-heading">本名</th>
                            <td class="information_table-data">
                                <div class="box_flex02">
                                    <div class="box_w40 margin-spacing-2_right">
                                        <label class="form-heading">姓</label>
                                        <span class="text">{state.basic_information.family_name}</span>
                                    </div>
                                    <div class="box_w40">
                                        <label class="form-heading">名</label>
                                        <span class="text">{state.basic_information.last_name}</span>
                                    </div>

                                </div>
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">フリガナ</th>
                            <td class="information_table-data">
                                <div class="box_flex02">
                                    <div class="box_w40 margin-spacing-2_right">
                                        <label class="form-heading">姓</label>
                                        <span class="text">{state.basic_information.family_kana}</span>
                                    </div>
                                    <div class="box_w40">
                                        <label class="form-heading">名</label>
                                        <span class="text">{state.basic_information.last_kana}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">生年月日</th>
                            <td class="information_table-data">
                                <div class="box_flex02">
                                    <div class="box_w40">
                                        <span class="text">{state.basic_information.birthday}</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">性別</th>
                            <td class="information_table-data">
                                <div class="box_flex02">
                                    <div class="box_w10">

                                        <span if={state.basic_information.sex === 1} class="text">男性</span>
                                        <span if={state.basic_information.sex === 2} class="text">女性</span>
                                        <span if={state.basic_information.sex === 3} class="text">その他</span>
                                        <span if={state.basic_information.sex === 4} class="text">無回答</span>

                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">住所</th>
                            <td class="information_table-data">
                                <div class="inner_form">

                                    <div style="margin-bottom: 1rem">
                                        <label class="form-heading">郵便番号</label>
                                        <span class="text">{state.basic_information.zip}</span>
                                    </div>

                                    <div style="margin-bottom: 1rem">
                                        <label class="form-heading">住所1（都道府県 市区町村 番地）</label>
                                        <span class="text">{state.basic_information.address1}</span>
                                    </div>

                                    <div>
                                        <label class="form-heading">住所2（建物名、フロアなど）</label>
                                        <span class="text">{state.basic_information.address2}</span>
                                    </div>


                                </div><!--/.inner_form-->
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">身分証明書</th>
                            <td class="information_table-data">
                                <p class="text notice">
                                    <strong>
                                        <span if={nodata}>未提出</span>
                                        <span if={!nodata && app}>確認中</span>
                                        <span if={!nodata && !app}>提出済み</span>
                                    </strong>
                                </p>
                            </td>
                        </tr>
                        <tr class="detail_table-row">
                            <th class="information_table-heading">マイナンバー</th>
                            <td class="information_table-data">
                                <p class="text notice">
                                    <strong>
                                        <span if={nodata}>未提出</span>
                                        <span if={!nodata && app}>確認中</span>
                                        <span if={!nodata && !app}>提出済み</span>
                                    </strong>
                                </p>
                            </td>
                        </tr>

                        <tr class="detail_table-row">
                            <th class="information_table-heading">適格請求書発行事業者</th>
                            <td class="information_table-data">

                                <p class="text">
                                    <strong>
                                        <invoice-provider-state-jname
                                                invoice_provider_state={state.eligible_invoice_provider.state}/>
                                    </strong>
                                    <span if={state.eligible_invoice_provider.state === 20}>
                                            (発行事業者番号：{state.eligible_invoice_provider.provider_number})
                                    </span>
                                </p>

                            </td>
                        </tr>

                    </table>

                </div>
            </section>
        </div>

    </div>
    <script>
        import di from "dependeny-injection";
        import invoiceProviderStateJname from "@tags/parts/info/invoice-provider-state-jname.riot";

        export default {
            components: {
                "invoice-provider-state-jname": invoiceProviderStateJname
            },
            app: false,
            nodata: true,
            state: {
                basic_information: {},
                eligible_invoice_provider: {state: 0} //初期状態はstate＝0にする
            },
            reload(data) {
                this.state = data;
                if (!this.state.basic_information) this.state.basic_information = {};
                if (!this.state.eligible_invoice_provider) this.state.eligible_invoice_provider = {state: 0}; //データが取れない場合、初期値＝state=0に戻す
                this.nodata = (Object.keys(this.state.basic_information).length <= 0);
                this.update();
            },
            onBeforeMount() {
                this.api = di.createApi('info');
                this.api.request('index', 'fetch')
                    .then(data => this.reload(data));
            }
        }
    </script>
</info-basic-information-tag>